import React from 'react';
import {
  EmojiContextInterface,
  PositionContextInterface,
  ResizeLoadingContextInterface,
  TabBubbleHandVisibleContextInterface,
} from '@interface';

export interface TournamentContextInterface {
  isTournament: boolean;
  currentSmallBlind: number;
  currentBigBlind: number;
  nextSmallBlind: number;
  nextBigBlind: number;
  nextBlindAt: string;
  playerRankings?: Array<{playerId: number; rank: number}>;
  tournamentStartTime: string;
  tournamentId?: number;
  tournamentWaitingStatus?: string;
  tournamentWaitingStatusData?: {
    currentPlayers: number;
    minPlayersRequired: number;
    remainingPlayers: number;
    remainingTimeMinutes: number;
    message: string;
    cancelTime?: string;
  };
}

// eslint-disable-next-line import/prefer-default-export
export const EmojiContext = React.createContext<EmojiContextInterface>({
  onClickEmoji: null,
  OnCancelShootEmoji: null,
  shootEmoji: null,
  emojiStatus: null,
  resetEmojiStatus: null,
  // isEmojiTargetSelectorVisible: false,
  toggleStickerDrawerVisibility: null,
  setSenderId: null,
  setReceiverId: null,
  emojiReceiverId: null,
  emojiSenderId: null,
  isEmojiSending: null,
  setIsEmojiSendingByContext: null,
  isEmojiButtonShown: null,
});

export const PositionContext = React.createContext<PositionContextInterface>({
  componentsPositions: null,
  updateComponentPosition: null,
  scaleUpValue: null,
  updateScaleUpValue: null,
  playerIconCenterPositions: null,
  updatePlayerIconCenterPositions: null,
  updatePlayerChipPlacementPosition: null,
  playerChipPlacementPosition: null,
});

export const ResizeLoadingContext = React.createContext<ResizeLoadingContextInterface>({
  setIsResizeLoading: null,
});

export const TabBubbleHandVisibleContext =
  React.createContext<TabBubbleHandVisibleContextInterface>({
    isMyHandVisibleInBubble: null,
    setIsMyHandVisibleInBubble: null,
  });

export const TournamentContext = React.createContext<TournamentContextInterface>({
  isTournament: null,
  currentSmallBlind: null,
  currentBigBlind: null,
  nextSmallBlind: null,
  nextBigBlind: null,
  nextBlindAt: null,
  playerRankings: null,
  tournamentStartTime: null,
  tournamentId: null,
  tournamentWaitingStatus: null,
  tournamentWaitingStatusData: null,
});
